module.exports = __webpack_public_path__ + "static/3-620b23ed192fcf88fe1874f36b0c64dd.png";